import { Trans } from '@lingui/react'
import { shape } from 'prop-types'
import { PureComponent } from 'react'
import { connectStateResults } from 'react-instantsearch-dom'
import { compose } from 'redux'

import { TENANT_AT, TENANT_COM, TENANT_FR, TENANT_IT } from 'shared/consts'
import SearchSuggestion from 'shared/experiments/components/NewSerp/SearchSugggestion'
import { getRefinedQueriesByTenant } from 'shared/experiments/components/NewSerp/SearchSugggestion/helpers'
import {
  EXPERIMENT_VARIATION,
  SERP_REFINED_QUERIES,
} from 'shared/experiments/consts'
import { getExperiments } from 'shared/experiments/utils/experiments'
import Experiment from 'views/components/utils/optimizely/Experiment'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'

import './FilterBox.scss'

class FilterBox extends PureComponent {
  render() {
    const { nbHits: total, query } = this.props.searchResults || {}
    const { experiments } = this.props.publicRuntimeConfig.pageProperties
    const { tenant, mountPoints } = this.props.publicRuntimeConfig.publicConfig

    const [refinedQueryExperiment] = getExperiments(
      [SERP_REFINED_QUERIES],
      experiments
    )

    let refinedQueries = null

    if (refinedQueryExperiment?.isEnabled) {
      const queryListByTenant = getRefinedQueriesByTenant(tenant)
      refinedQueries = queryListByTenant.find(
        refinedQuery =>
          //below regex removes empty spaces within the string eg: vitamin     d => vitamind
          refinedQuery.query.toLowerCase().replace(/ /g, '') ===
          String(query).toLowerCase().replace(/ /g, '')
      )
    }

    return (
      <div className="e-FilterBox u-position--relative">
        <ul className="l-flex l-flex--wrap a-list-reset">
          <li>
            <span
              className="u-font-weight--bold u-color--grey e-FilterBox__title"
              data-qa-id="search-result-result-counter"
              suppressHydrationWarning
            >
              <Trans
                id="searchResults.label.totalResultsNumber"
                values={{ total }}
              />
            </span>
          </li>
        </ul>
        {refinedQueryExperiment?.isEnabled && refinedQueries && (
          <Experiment name={SERP_REFINED_QUERIES}>
            {() =>
              refinedQueryExperiment?.variant !==
                EXPERIMENT_VARIATION.DEFAULT && (
                <div className="l-flex l-flex--wrap l-flex--start u-margin--top e-RefineSearchWrapper">
                  <h3 className="u-font-weight--bold u-no-margin">
                    {(tenant === TENANT_FR || tenant === TENANT_IT) && (
                      <>
                        <Trans id="searchResults.refine" /> {query}
                      </>
                    )}

                    {(tenant === TENANT_COM || tenant === TENANT_AT) && (
                      <>
                        {query} <Trans id="searchResults.refine" />
                      </>
                    )}
                  </h3>
                  {refinedQueries.suggestions.map(eachQuery => (
                    <SearchSuggestion
                      key={eachQuery}
                      suggestion={eachQuery}
                      variation={refinedQueryExperiment?.variant}
                      mountPoints={mountPoints}
                      currentQuery={query}
                    />
                  ))}
                </div>
              )
            }
          </Experiment>
        )}
      </div>
    )
  }
}

FilterBox.propTypes = {
  searchResults: shape({}),
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
}

FilterBox.defaultProps = {
  searchResults: null,
}

export default compose(connectStateResults, withShopAndRuntimeConfig)(FilterBox)
